export const maxLoanTerms = 25;
